import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import { LicenseInsight } from '../../../Types';

interface Props {
  licenseInsight: LicenseInsight;
}

function LicenseInsightMessage({ licenseInsight }: Props) {
  switch (licenseInsight.kind) {
    case 'overallocation-alert':
      return (
        <T
          kind="You are over allocated by {{count}} license"
          count={licenseInsight.overallocatedBy}
        />
      );
    case 'expiration-alert':
      return (
        <div className="text-amber-600">
          <T kind="A license is expiring in less than 90 days" />
        </div>
      );
    case 'invite-more-participants-alert':
      return <T kind="Invite more participants to collections" />;
  }
}

export default observer(LicenseInsightMessage);
